$(document).ready(function () {
   
    $('.SubscriptionList__faqs-block .AccordionContent__header').on('click', function () {

    const $row = $(this).closest('.AccordionContent__row');
    const $content = $row.find('.AccordionContent__content');

    if ($row.hasClass('is-active')) {
        $content.stop(true, true).slideUp(300);
        $row.removeClass('is-active');
    } else {

       $('.SubscriptionList__faqs-block .AccordionContent__content')
            .stop(true, true)
            .slideUp(300);

       $('.SubscriptionList__faqs-block .AccordionContent__row')
            .removeClass('is-active');

         $content.stop(true, true).slideDown(300);
         $row.addClass('is-active');
  }

});

    // Preselect the annual plan (fall back to the first plan) so the form
    // loads with a subscription already chosen. No scroll side-effects.
    (function preselectAnnualPlan() {
        var $checked = $('.SubscriptionList__form .SubscriptionList__body input[name="selling_plan"]:checked');
        if (!$checked.length) {
            var $annual = $('.SubscriptionList__form .SubscriptionList__body .SubscriptionList__form-radio--annual input[name="selling_plan"]');
            if (!$annual.length) {
                $annual = $('.SubscriptionList__form .SubscriptionList__body input[name="selling_plan"]').first();
            }
            if (!$annual.length) return;
            $annual.prop('checked', true);
            $checked = $annual;
        }
        var val = $checked.val();
        if (!val) return;
        $('button.select-subscription').removeClass('is-selected');
        $('button.select-subscription[prodid="' + val + '"]').addClass('is-selected');
        $('button.add_to_cart').prop('disabled', false).removeAttr('disabled');
    })();

function targets(val){
    const target = $('[data-prod-id="' + val + '"]');
        if (target.length) {
        $("html, body").animate({
            scrollTop: target.offset().top
        }, 600);
        }
}

 $("#faqs-link, #compare-link").on("click", function (e) {
    e.preventDefault();
    const val = $(this).attr("id").replace('-link', '');
    targets(val);
  });

   $(document).on('click', '.SubscriptionList__form .SubscriptionList__body .SubscriptionList__form-radio', function () {
       var $input = $(this).find('input[name="selling_plan"]');
       if (!$input.length) return;
       // Force-check the input even if label click didn't fire it
       $input.prop('checked', true);

       var val = $input.val();
       $('button.select-subscription').removeClass('is-selected');
       $('button.select-subscription[prodid="'+val+'"]').addClass('is-selected');
       $('button.add_to_cart').prop('disabled', false).removeAttr('disabled');

       if (window.matchMedia('(min-width: 1024px)').matches) {
           targets(val);
           const $heroSection = $('button.select-subscription[prodid="'+val+'"]').closest('.SubscriptionList__hero-section');
           if ($heroSection.length) {
               $("html, body").animate({
                   scrollTop: $heroSection.offset().top
               }, 600);
           }
       }
   });


$(document).on('click', 'button.select-subscription', function (e) {
    e.preventDefault();
    $('button.select-subscription').removeClass('is-selected');
    $(this).addClass('is-selected');
    var sellingid = $(this).attr('prodid');

    // Try to check the matching radio; if no match, fall back to first available radio
    var $radio = $('.SubscriptionList__form .SubscriptionList__body .SubscriptionList__form-radio input[value="' + sellingid + '"]');
    if (!$radio.length) {
        $radio = $('.SubscriptionList__form .SubscriptionList__body .SubscriptionList__form-radio input[name="selling_plan"]').first();
    }
    $radio.prop('checked', true).trigger('change');

    // Always enable Add to Cart so the user can proceed
    $('button.add_to_cart').prop('disabled', false).removeAttr('disabled');

    const $heroSection = $(this).closest('.SubscriptionList__hero-section');
    const target = $heroSection.length
        ? $heroSection
        : $('label[for="plan-'+sellingid+'"]');
    if (target.length) {
        $("html, body").animate({
            scrollTop: target.offset().top
        }, 600);
    }
});



function subscriptionfor(){
    if ($('input[name="product_for"][value="gift"]:checked').length > 0) {
    $('.SubscriptionList__form .SubscriptionList__footer .SubscriptionList__form-email').css({'opacity':'1','pointer-events':'auto','top':'0'});
    $('.SubscriptionList__form .SubscriptionList__footer .SubscriptionList__form-radio').css({'opacity':'0','pointer-events': 'none'});
    $('button.recipient-back').css({'opacity':'1','pointer-events':'auto'});

} else {
    $('.SubscriptionList__form .SubscriptionList__footer .SubscriptionList__form-email').css({'opacity':'0','pointer-events': 'none'});
    $('.SubscriptionList__form .SubscriptionList__footer .SubscriptionList__form-radio').css({'opacity':'1','pointer-events':'auto','top':'0'});
    $('button.recipient-back').css({'opacity':'0','pointer-events':'none'});
}
}

$('.SubscriptionList__form .SubscriptionList__footer .SubscriptionList__form-radio').on('click', function () {
   subscriptionfor();
});
$('button.recipient-back').on('click', function (e) {
    e.preventDefault();
   $('input[name="product_for"][value="myself"]').prop('checked', true)
        .trigger('change');
        subscriptionfor();
});




$('button.add_to_cart').on('click', function (e) {

    e.preventDefault();

    let properties = {};

    // agar gift selected hai
    if ($('input[name="product_for"][value="gift"]:checked').length > 0) {

        let gift_email = $.trim($('input[name="gift_email"]').val());

        // agar email empty hai to add to cart mat karo
        if (gift_email === '') {
            $('input#gift_email').css('border-bottom','1px solid red');
            return false;
        }
        else{
             $('input#gift_email').css('border-bottom','1px solid #000');
        }

        properties = {
            gift_email: gift_email,
            "This is a gift": "Yes"
        };
    }

    let checked_radio = $('input[name="selling_plan"]:checked');
    let selling_plan  = checked_radio.val();
    let variant_id    = checked_radio.data('variant-id') || $(this).data('id');

    let mainItem = {
        id: variant_id,
        quantity: 1,
        selling_plan: selling_plan
    };

    if (Object.keys(properties).length > 0) {
        mainItem.properties = properties;
    }

    // Check if annual plan is selected; if so, attach free gift variant
    let wrapper = document.querySelector('.SubscriptionList');
    let annualGiftVariantId = wrapper ? wrapper.getAttribute('data-annual-gift-variant-id') : '';
    let annualPlanIdsRaw = wrapper ? wrapper.getAttribute('data-annual-plan-ids') : '';
    let annualPlanIds = (annualPlanIdsRaw || '')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);
    let isAnnual = annualPlanIds.includes(String(selling_plan));

    // Product IDs that also get the free binder gift
    const binderGiftProductIds = ['9636112761073'];
    let currentProductId = wrapper ? wrapper.getAttribute('data-product-id') : '';
    let productGetsBinder = binderGiftProductIds.includes(String(currentProductId));

    console.log('[add to cart]', {
        selling_plan: selling_plan,
        annualGiftVariantId: annualGiftVariantId,
        annualPlanIds: annualPlanIds,
        isAnnual: isAnnual,
        currentProductId: currentProductId,
        productGetsBinder: productGetsBinder
    });

    let items = [mainItem];
    if ((isAnnual || productGetsBinder) && annualGiftVariantId) {
        items.push({
            id: parseInt(annualGiftVariantId, 10),
            quantity: 1
        });
    }

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({ items: items }),
        contentType: 'application/json',
        dataType: 'json',
        success: function () {
          import('@theme/events').then(({ CartUpdateEvent }) => { const cartDrawer = document.querySelector('cart-drawer-component'); fetch('/cart.js') .then(res => res.json()) .then(cart => { const event = new CartUpdateEvent(cart, 'manual-trigger', { itemCount: cart.item_count, source: 'fad-refresh', sections: {} }); document.dispatchEvent(event); if (cartDrawer?.hasAttribute('auto-open')) { cartDrawer.open(); } }); });
          document.querySelector('.cart-bubble')?.click();
         },
        error: function (xhr) {
            console.log(xhr.responseText);
        }
    });

});

$(document).on('click', '.SubscriptionList__compare-blocks .SubscriptionList__compare-trigger', function(){
    var txt = $(this).text().trim();
    $('.SubscriptionList__compare-blocks .SubscriptionList__compare-trigger').removeClass('is-active');
    $(this).addClass('is-active');
    $('.SubscriptionList__compare-blocks .tabs-content').removeClass('active-tab');
    $('.SubscriptionList__compare-blocks .tabs-content[tab="'+txt+'"]').addClass('active-tab');
});

 $('.hamburger-menu button').click(function(){
    $(this).addClass('mega-menu-open');
    $('.mega-menu-wrapper').addClass('menu_slide');
});
$('.mega-menu-close').click(function(){
    $('.hamburger-menu button').removeClass('mega-menu-open');
    $(this).parent('.mega-menu-wrapper').removeClass('menu_slide');
});

 const emailInput = document.getElementById("gift_email");
  const addToCartBtn = document.getElementById("addtocart");

  emailInput.addEventListener("keydown", function(event) {
    if (event.key === "Enter") {
      event.preventDefault(); // form reload rokne ke liye
      addToCartBtn.click();  // Add to Cart button click
    }
  });

});

